<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <el-row>
        <el-col :span=8>
          <el-form ref="pInfo1" :model="pInfo1" label-width="120px">
            <el-form-item label="guid" class="h20">
              <el-input v-model="pInfo1.guid" placeholder="guid,修改时用"></el-input>
            </el-form-item>
            <el-form-item label="归类1" class="h20">
              <el-input v-model="pInfo1.type1"  placeholder="显示到最上方的类别"></el-input>
            </el-form-item>
            <el-form-item label="归类2" class="h20">
              <el-input v-model="pInfo1.type2" placeholder="备用，尚未用到"></el-input>
            </el-form-item>
            <el-form-item label="关键词" class="h20">
              <el-input v-model="pInfo1.keyword" placeholder="会显示到类别1的下方"></el-input>
            </el-form-item>
            <el-form-item label="标题" class="h20">
              <el-input v-model="pInfo1.title" placeholder="此处文字会显示到正文中，可写可不写，最好写上"></el-input>
            </el-form-item>
            <el-form-item label="原作者" class="h20">
              <el-input v-model="pInfo1.author2" placeholder="原作者"></el-input>
            </el-form-item>
            <el-form-item label="答案类型" class="h20">
              <el-input v-model="pInfo1.atype" placeholder="0为输入，1为单选题，2为多选题"></el-input>
            </el-form-item>
            <el-form-item label="答案标记" class="h20">
              <el-input v-model="pInfo1.amark" placeholder="即显示在输入答案前的提示，同时也是选择题选项"></el-input>
            </el-form-item>
            <el-form-item label="答案是否数值" class="h20">
              <el-input v-model="pInfo1.aisnumber" placeholder="数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"></el-input>
            </el-form-item>
            <el-form-item label="答案格式" class="h20">
              <el-input v-model="pInfo1.aformat" placeholder="答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"></el-input>
            </el-form-item>
            <el-form-item label="答案" class="h20">
              <el-input v-model="pInfo1.answer" placeholder="答案"></el-input>
            </el-form-item>
            <el-form-item label="主题号" class="h20">
              <el-input v-model="pInfo1.main" placeholder="主题号，知识点大题号"></el-input>
            </el-form-item>
            <el-form-item label="次题号" class="h20">
              <el-input v-model="pInfo1.minor" placeholder="次题号，知识点内小题号"></el-input>
            </el-form-item>
            <el-form-item label="等级点" class="h20">
              <el-input v-model="pInfo1.rank" placeholder="等级变化点，24k为1，23k为2，22k为3...."></el-input>
            </el-form-item>
            <el-form-item label="keyword2" class="h20">
              <el-input v-model="pInfo1.keyword2" placeholder="用于生成静态页面的keywords，尽量多填"></el-input>
            </el-form-item>
            <el-form-item label="description" class="h20">
              <el-input v-model="pInfo1.description" placeholder="用于生成静态页面的description，尽量多填"></el-input>
            </el-form-item>
            <el-form-item label="动画JS名称" class="h20">
              <el-input v-model="pInfo1.animateJSNames" placeholder="只写名称如12k_pid_6,forward_1等，不加.js，多个用逗号分隔"></el-input>
            </el-form-item>
            </el-form>
          <el-row type="flex" align="middle" justify="center" style="margin-top: 30px;">
            <el-button @click="closeDlg">取消</el-button>
            <el-button v-if="showEditBtn" type="primary" @click="saveEdit">保存修改</el-button>
            <el-button v-if="type == 0" type="primary" @click="examine1">创建新题目，审核通过</el-button>
            
            <!--<el-button v-if="type == 0" type="primary" @click="examine2">加入老知识点，审核通过</el-button>
            <el-button @click="testCheckAnswer">测试检查答案</el-button>
            <el-button @click="testGetProblemGuids">测试获取当前题及前后题guid</el-button>
            <el-button @click="testGetNextProblemGuids">测试获取下一题guid</el-button>-->
          </el-row>
          <el-row type="flex" align="middle" justify="center" style="margin-top: 30px;">
            <el-button v-if="type == 0" type="primary" @click="updateLastProblemU">更新已做到最后一题的用户</el-button>
            <el-button v-if="type == 0" type="" @click="commit2knowledge">提交本题到知识点</el-button>
          </el-row>
        </el-col>
        <el-col :span=1>
          &nbsp;
        </el-col>
        <el-col :span=15>
          <el-row>
            <span>题目内容</span>
          </el-row>
          <el-row >
            <div id="standalone-container" style="margin: 10px auto;max-width: 100%;">
              <div id="toolbar"></div>
              <div id="editor" style="height: calc(100vh - 220px);"></div>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  import { examinePass, updateLastProblemUser, editProblemByGuid, getDshProblemByID, getProblemByGuidManager, getProblemByGuid, checkAnswerByGuid, getNextProblemGuid } from '@/api/api_examine.js'
  import { setEditor } from '@/utils/quill.table'
  import { addNewKnowledge} from '@/api/api_knowledge.js'
  
  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        showEditBtn: false,
        type: '0',
        guid: '',
        dshid: -1,
        isEditData: false,
        pInfo1: {
          id: 0,
          guid: '',
          type1: '',
          type2: '',
          type3: '',
          type4: '',
          main: 1,
          minor: 1,
          aisnumber: '',
          aformat: '',
          keyword: '',
          title: '',
          content: '',
          atype: '',
          amark: '',
          aselect: '',
          answer: '',
          rank: 0,
          author2: '', // 题目原作者
          animateJSNames: ''
        },
        kInfo: {
          guid: '',
          title: '',
          type: '',
          content: '',
          author2Guid: '', // 知识点原作者
          description: '',
          keyword2: ''
        },
        toolbarOptions: [
          // ['contain'],
          [{'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5']}],
          [{'table': 'append-row'}],
          [{'table': 'append-col'}],
          [{'table': 'remove-row'}], // cursor needs to be in the table
          [{'table': 'remove-col'}], // cursor needs to be in the table
          [{'table': 'remove-table'}], // cursor needs to be in the table
          [{'table': 'cell-background'}],
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{'header': 1}, {'header': 2}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'direction': 'rtl'}],
          [{'size': ['small', false, 'large', 'huge']}],
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [{'color': []}, {'background': []}],
          [{'align': []}],
          ['link', 'image'],
          ['formula', 'clean', 'video']
        ],
        quill: null
      }
    },
    computed: {
      title () {
        if (this.isEditData === true) {
          this.showEditBtn = true
        } else {
          this.showEditBtn = false
        }
        return `审核题目-${this.isEditData === true ? '修改' : '新增'}`
      }
    },
    watch: {
      show: function (val) {
        if (val) {
          this.markDown()
        }
      }
    },
    methods: {
      markDown () {
        setTimeout(() => {
          let options = {
            modules: {
              formula: true,
              syntax: true,
              toolbar: {
                container: this.toolbarOptions,
                handlers: {
                  image: this.imageHandler
                }
              }
            },
            scrollingContainer: '#standalone-container',
            placeholder: 'Compose an epic...',
            theme: 'snow'
          }

          if (!this.quill) {
            this.quill = new window.Quill('#editor', options)
            setEditor(this.quill)
          }
          this.loadData()
        }, 1000)
      },
      closeDlg () {
        this.show = false
      },
      imageHandler () {
        console.log('65')
        var range = this.quill.getSelection()
        var value = prompt('What is the image URL')
        this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER)
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '审核题目',
          message: msg,
          type: type
        })
      },
      loadData () {
        // 直接从正式题库加载并修改
        if (this.isEditData === true) {
          this.loading = true
          getProblemByGuidManager(this.guid).then((res) => {
            let data = res.data
            if (data.isOk) {
              this.pInfo1 = data.data[0]
              let tm = JSON.parse(this.pInfo1.content)
              console.log(tm.ops)
              if (this.quill) {
                this.quill.setContents(tm.ops)
                this.quill.enable(true)
              } else {
                console.log('quill初始化失败。')
              }
            } else {
              this.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！')
            }
            this.loading = false
          }).catch((err) => {
            this.showMsg(err)
            this.loading = false
          })
        } else {
          // 从待审核题库加载并修改
          this.loading = true
          console.log('this.dshid==' + this.dshid)
          getDshProblemByID(this.dshid).then((res) => {
            let data = res.data
            if (data.isOk) {
              this.pInfo1 = data.data[0]
              let tm = JSON.parse(this.pInfo1.content)
              console.log(tm.ops)
              if (this.quill) {
                this.quill.setContents(tm.ops)
                this.quill.enable(true)
              } else {
                console.log('quill初始化失败。')
              }
            } else {
              this.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！')
            }
            this.loading = false
          }).catch((err) => {
            this.showMsg(err)
            this.loading = false
          })
        }
      },
      examine1 () {
        // 创建新题目
        console.log('审核通过并创建新题目，this.pInfo1=' + JSON.stringify(this.pInfo1))
        this.pInfo1.content = JSON.stringify(this.quill.getContents())
        examinePass(this.pInfo1).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('创建新题目成功。', 'info')
            } else {
              this.showMsg('创建新题目失败。', 'info')
            }
          } else {
            this.showMsg('创建新题目不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`保存新题失败。${err}`)
        })
      },
      saveEdit () {
        // 修改题目
        console.log('修改题目 this.pInfo1=' + JSON.stringify(this.pInfo1))
        this.pInfo1.content = JSON.stringify(this.quill.getContents())
        console.log('this.pInfo1.content=' + this.pInfo1.content)
        delete this.pInfo1['id']
        editProblemByGuid(this.pInfo1).then((res) => {
          if (res.data) {
            console.log('修改题目 res.data=' + JSON.stringify(res.data))
            if (res.data.isOk === true) {
              this.showMsg('修改新题目成功。', 'info')
            } else {
              this.showMsg('修改新题目失败。', 'info')
            }
          } else {
            this.showMsg('修改新题目不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`修改新题失败。${err}`)
        })
      },
      testCheckAnswer () {
        let answerInfo = {}
        answerInfo.answer = 'B'
        answerInfo.pmain = 1
        answerInfo.passtype = 2
        answerInfo.pguid = '5d64c6f08bd511e787c68980854367e6'
        answerInfo.pminor = 1
        console.log('anwserInfo1=', answerInfo)
        checkAnswerByGuid(answerInfo).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('checkAnswerByGuid1。', 'info')
            } else {
              this.showMsg('checkAnswerByGuid2。', 'info')
            }
          } else {
            this.showMsg('checkAnswerByGuid3。', 'info')
          }
        }).catch(err => {
          this.showMsg(`checkAnswerByGuid4。${err}`)
        })
      },
      testGetProblemGuids () {
        getProblemByGuid(this.guid).then((res) => {
          let data = res.data
          console.log('--data--', data)
          if (data.isOk) {

          } else {
            this.showMsg('获取题目GUID失败！')
          }
        })
      },
      testGetNextProblemGuids () {
        getNextProblemGuid(this.guid, 1).then((res) => {
          let data = res.data
          console.log('--data--', data)
          if (data.isOk) {

          } else {
            this.showMsg('获取题目GUID失败！')
          }
        })
      },
      updateLastProblemU () {
        let level = {}
        level.pmain = this.pInfo1.main
        updateLastProblemUser(level).then((res) => {
          this.showMsg(res.data)
        })
      },
      //新增为知识点
      commit2knowledge(){
          this.kInfo.title = this.pInfo1.title
          this.kInfo.content =this.pInfo1.content  
          this.kInfo.type = this.pInfo1.type1
          this.kInfo.author2Guid = this.pInfo1.author2
          this.kInfo.keyword2=this.pInfo1.keyword2
          this.kInfo.description=this.pInfo1.description

          addNewKnowledge(this.kInfo).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('添加知识点成功。', 'info')
              } else {
                this.showMsg('添加知识点失败。', 'info')
              }
            } else {
              this.showMsg('添加知识点不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`添加知识点失败。${err}`)
          })
      },
    }
  }
</script>

<style>
  .h20{
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// main.vue?3ceae2ee